export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="rounded-3xl overflow-hidden relative">
          <div className="relative aspect-[21/9] md:aspect-[21/7] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20soft%20olive%20green%20and%20terracotta%20tones%20blending%20seamlessly%2C%20subtle%20texture%20like%20handmade%20cotton%20paper%2C%20clean%20modern%20minimalist%20aesthetic%2C%20no%20text%20no%20people%2C%20calm%20inviting%20atmosphere%2C%20high%20resolution%20editorial%20backdrop&width=1920&height=800&seq=cta-bg-jun27-v2&orientation=landscape"
              alt="Get Latest Spreadsheet Now"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-foreground-950/40"></div>
          </div>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <div className="mb-6 md:mb-8">
              <p className="text-sm md:text-base text-background-50/90 font-medium mb-3">
                Trusted by buyers in 🇺🇸 🇬🇧 🇨🇦 🇦🇺
              </p>
              <p className="text-xs md:text-sm text-background-50/70 flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
                <span>Updated Weekly Spreadsheet Data</span>
                <span className="hidden sm:inline">•</span>
                <span>Verified Agents Only</span>
                <span className="hidden sm:inline">•</span>
                <span>Beginner-Friendly Guides</span>
              </p>
            </div>

            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-3 leading-tight">
              Start Using ItaobuySpreadsheet Today
            </h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mb-8">
              Access updated spreadsheets, compare agents, and start saving money immediately.
            </p>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-10 py-4 rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Get Latest Spreadsheet Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}